/**
 * @generated SignedSource<<b35382826855d5f90b294e7e96220021>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InputCharacteristicResponseGridSingleSelect_characteristic$data = {
  readonly answers: ReadonlyArray<{
    readonly id: string;
    readonly text: string;
  }>;
  readonly id: string;
  readonly rows: ReadonlyArray<{
    readonly id: string;
    readonly text: string;
  }>;
  readonly " $fragmentType": "InputCharacteristicResponseGridSingleSelect_characteristic";
};
export type InputCharacteristicResponseGridSingleSelect_characteristic$key = {
  readonly " $data"?: InputCharacteristicResponseGridSingleSelect_characteristic$data;
  readonly " $fragmentSpreads": FragmentRefs<"InputCharacteristicResponseGridSingleSelect_characteristic">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "text",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InputCharacteristicResponseGridSingleSelect_characteristic",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "CharacteristicAnswerNode",
      "kind": "LinkedField",
      "name": "answers",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CharacteristicRowNode",
      "kind": "LinkedField",
      "name": "rows",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    }
  ],
  "type": "CharacteristicNode",
  "abstractKey": null
};
})();

(node as any).hash = "7ad24b4a2f239dd2be399e4b65d5d229";

export default node;
